<script>
import { mapGetters } from 'vuex'
import TeamResource from '@/resources/team'

export default {
    name: 'AccountLapTimes',
    computed: {
        ...mapGetters(['userId']),
    },
    data() {
        return {
            hasTeams: false,
        }
    },
    async mounted() {
        const teams = await TeamResource.filterAll({ members: this.userId })
        this.hasTeams = teams.length > 0
    },
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Tiempos de vuelta</h4>
            <p class="text-muted mb-0">Revisa tu rendimiento en carrera y compáralo con el de otros.</p>
        </div>
        <b-row>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="stopwatch-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Mis vueltas</h6>
                            <p class="text-muted small mb-3">Consulta tus tiempos de vuelta personales y tu historial de sesiones.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'laps' }">Ir a Mis vueltas</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="bar-chart-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Clasificaciones</h6>
                            <p class="text-muted small mb-3">Consulta tu posición frente a otros pilotos en cada circuito.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'leaderboards' }">Ir a Clasificaciones</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
            <b-col md="6" class="mb-3" v-if="hasTeams">
                <b-card class="h-100">
                    <div class="d-flex align-items-start">
                        <b-icon icon="people-fill" scale="2" class="text-primary mr-3 flex-shrink-0" style="margin-top: 2px" />
                        <div>
                            <h6 class="mb-1">Equipos</h6>
                            <p class="text-muted small mb-3">Gestiona los equipos con los que compites en series por puntos.</p>
                            <b-button variant="outline-primary" size="sm" :to="{ name: 'accountTeams' }">Ir a Equipos</b-button>
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
